import React from "react";
import styled from "styled-components";
import { COLORS } from "../../COLORS";
import Basic from "./Formules/Basic";
import Premium from "./Formules/Premium";
import Gold from "./Formules/Gold";

const Formules = () => {
  return (
    <StyledFormules className="animate__animated animate__fadeInDown">
      <h3>Faire connaitre votre business</h3>
      <p>Place limitée</p>
      <div className="formule free">
        <strong className="name-formule"> 🆓 FREE (GRATUIT)</strong>
        <span>Pour les porteurs de projet - testez votre idée</span>
        <ul>
          <li>✅ Annonce offerte - visible 2 semaines </li>
          <li>✅ Emplacement : Business/bêta</li>
          <li>✅ Présentation : Texte</li>
        </ul>
      </div>
      <Basic />
      <Premium />
      <Gold />
    </StyledFormules>
  );
};

export default Formules;
const StyledFormules = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  h3 {
    width: 100%;
    text-align: center;
    font-size: 2.3em;
    color: ${COLORS.border_and_text_blue};
    margin-bottom: 10px;
  }
  p {
    width: 100%;
    text-align: center;
    color: ${COLORS.orange_new};
    margin: 10px auto;
  }
  .free {
    background: ${COLORS.freebg} !important;
  }
  .formule {
    background: ${COLORS.main};
    border: solid 2px ${COLORS.green};
    border-radius: 5px;
    color: white;
    padding: 10px;
    max-width: 23%;
    display: flex;
    flex-direction: column;
    .name-formule {
      display: block;
      font-size: 1.1em;
      text-align: center;
      color: ${COLORS.border_and_text_blue};
    }
    span {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 1.2em;
      color: ${COLORS.orange_new};
      margin: 15px 0px;
    }
    ul {
      li {
        margin-top: 20px;
      }
    }
  }

  @media screen and (max-width: 445px) {
    .formule {
      min-width: 85%;
      margin-bottom: 30px;
    }
  }
`;
